/**
 * Lock Brief is only allowed for replies to a /generate (or /generated) prompt.
 * Already-locked messages stay eligible so users can unlock them.
 */

const getMessageText = (message) =>
  String(
    message?.displayContent ??
      message?.content ??
      message?.text ??
      message?.contentText ??
      "",
  ).trim();

export const isGenerateBriefPrompt = (text) =>
  /^\/generated?\b/i.test(String(text || "").trim());

export const isLockableBriefMessage = ({
  message,
  messages,
  messageIndex,
  isAlreadyLocked = false,
} = {}) => {
  if (isAlreadyLocked) return true;

  const role = String(message?.role || "").toLowerCase();
  if (role && role !== "ai" && role !== "assistant") return false;

  if (!Array.isArray(messages) || messageIndex == null) return false;

  for (let i = messageIndex - 1; i >= 0; i -= 1) {
    const prev = messages[i];
    if (prev?.role === "user") {
      return isGenerateBriefPrompt(getMessageText(prev));
    }
  }

  return false;
};
